<template>
  <div ref="holder" class="holder" />
</template>

<style scoped>
.holder {
  pointer-events: none;
}
.holder >>> svg > * {
  pointer-events: painted;
  transition: stroke-width 0.3s ease;
}
.holder >>> .selected {
  -webkit-animation: dash 30s linear infinite;
  stroke-dasharray: 8;
}
@-webkit-keyframes dash {
  to {
    stroke-dashoffset: -1000;
  }
}
</style>

<script>
import _ from 'lodash'

import {
  brick_port_endpoint_positions,
  SVGArrowDrawerBase,
} from './workflow_common.js'

import { WorkflowCanvasConnectorGhostHandler } from './workflow_core.vue'

// *****************************************************************************

class SVGArrowDrawer extends SVGArrowDrawerBase {
  constructor(holding_div) {
    super(holding_div, false)
  }
}

// *****************************************************************************

export default {
  name: 'WorkflowCanvasConnectorGhost',
  components: {},
  props: ['workflow_interface', 'value', 'options'],
  data() {
    let res = {
      uid: _.uniqueId('uniqueid'),
    }
    return res
  },
  computed: {
    arrow_coords() {
      let c = this.workflow_interface.component

      let [brick_from_nb, endpoint_from] = this.workflow_interface.drop_source
      let brick_from = c.bricks_undeleted.bricks[brick_from_nb]
      let from = this.workflow_interface.drop_position
      if (!_.isUndefined(brick_from)) {
        const { x: fromxb, y: fromyb } = brick_from.position
        const { x: fromxc, y: fromyc } = brick_port_endpoint_positions[
          endpoint_from
        ]
        from = { x: fromxb + fromxc, y: fromyb + fromyc }
      }

      let [brick_to_nb, endpoint_to] = this.workflow_interface.drop_target
      let brick_to = c.bricks_undeleted.bricks[brick_to_nb]
      let to = this.workflow_interface.drop_position
      if (!_.isUndefined(brick_to)) {
        const { x: toxb, y: toyb } = brick_to.position
        const { x: toxc, y: toyc } = brick_port_endpoint_positions[endpoint_to]
        to = { x: toxb + toxc, y: toyb + toyc }
      }

      const res = { from, to }
      return res
    },
  },
  watch: {
    arrow_coords(newval) {
      this.drawer.update(newval)
    },
  },
  mounted() {
    this.drawer = new SVGArrowDrawer(this.$refs.holder)
    this.drawer.update(this.arrow_coords)
    this.handler = new WorkflowCanvasConnectorGhostHandler(this)
    this.workflow_interface.install(this.handler)
  },
  beforeDestroy() {
    this.handler.stop()
    this.workflow_interface.uninstall(this.handler)
    this.drawer.stop()
  },
  methods: {},
}
</script>
